import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { genfunction } from 'helpers'
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    wheelChairScreenAssist: {
        bottom: 0,
        position: "fixed",
        marginBottom: "120"
    }
}));

const PinCodeDialogeBox = props => {
    const { open, title, message, button1text, button2text, button1clickhandler, button2clickhandler, pinTextChange } = props;
    const classes = useStyles();
    return (
        <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {ReactHtmlParser(genfunction.replaceEscapeCharacters(message))}
                    <TextField autoFocus fullWidth label="Pin" onChange={(event) => { pinTextChange(event.target.value) }}></TextField>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {button1text == undefined ? null : (<Button onClick={button1clickhandler} variant="outlined" color="primary">
                    {button1text}
                </Button>)}
                {button2text == undefined ? null : (<Button onClick={button2clickhandler} variant="contained" color="primary">
                    {button2text}
                </Button>)}
            </DialogActions>
        </Dialog>
    );
};

PinCodeDialogeBox.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    button1text: PropTypes.string.isRequired,
    button1clickhandler: PropTypes.func.isRequired
};

export default PinCodeDialogeBox;
